import React from 'react';
import './DynaInput.scss';

const DynaTimePicker = (props) => {

  const svgTime = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
    >
      <path
        fill="#B9B9B9"
        d="M10 18.958c-4.942 0-8.958-4.017-8.958-8.959 0-4.941 4.016-8.958 8.958-8.958s8.958 4.017 8.958 8.958c0 4.942-4.016 8.959-8.958 8.959zM10 2.29c-4.25 0-7.708 3.458-7.708 7.708S5.75 17.708 10 17.708s7.708-3.459 7.708-7.709S14.25 2.291 10 2.291z"
      ></path>
      <path
        fill="#B9B9B9"
        d="M13.091 13.274a.558.558 0 01-.316-.091L10.19 11.64c-.641-.383-1.116-1.225-1.116-1.967V6.258a.63.63 0 01.625-.625.63.63 0 01.625.625v3.416c0 .3.25.742.508.892l2.583 1.542c.3.175.392.558.217.858a.642.642 0 01-.542.309z"
      ></path>
    </svg>
  );

  const onChangeHandler = (event) => {
    const key = props.name;
    props.setDataFromComponent({[key]: event.target.value});
  };

  return (
    <div className={`main-dyna-input ${props.className !== undefined ? props.className : ""}`}>
      <label htmlFor={props.name}>{props.label}</label>
      <input
        type="time"
        id={props.name}
        name={props.name}
        value={props.value}
        onChange={onChangeHandler}
      />
      <div className={"svg-icon-side"}>
        {svgTime}
      </div>
    </div>
  );
};

export default DynaTimePicker;
